<template>
  <registration-main @back="goBack">
    <template slot="nav">
      <div class="registrationDetailNav">
        <p>{{classTrain.name}}</p>
      </div>
    </template>
    <template slot="main" >
      <div class="registrationDetailMain">
        <yioks-loading v-show="showDate"></yioks-loading>
        <div v-if="!showDate" class="mainBody">
          <div class="scrollArea">
            <vue-scroll :ops="ops" ref="vs">
              <div class="mainDate">
                <div class="mainUp">
                  <div class="upLeft">
                    <div class="titleWrap">
                      <div class="title">
                        <p>培训班信息</p>
                      </div>
                    </div>
                    <div class="infoWrap">
                      <template v-if="dataPhase.length > 0">
                        <p>培训第一阶段：{{dataPhase[0].start_date | time(false)}} 至 {{dataPhase[0].end_date | time(false)}}</p>
                        <p>培训第二阶段：{{dataPhase[1].start_date | time(false)}} 至 {{dataPhase[1].end_date | time(false)}}</p>
                      </template>
                      <template v-else>
                        <p>开班时间：{{ classTrain.start_date | time(false)}} 至 {{ classTrain.end_date | time(false)}}</p>
                      </template>
<!--                      <p>讲师：<span>{{classTrain.teacher_off_name}}</span><span v-if="classTrain.teacher_name">,{{classTrain.teacher_name}}</span></p>-->
                      <p>承办协会：{{classTrain.organizer}}</p>
                      <p>报到时间：{{classTrain.regis_start_time | time}}</p>
                      <p>报到地点：{{classTrain.regis_address}}</p>
                      <p  class="intro">备注：<span v-if="admission.remark">{{admission.remark}}</span>
                        <span v-else>--</span>
                      </p>
                    </div>
                  </div>
                  <div class="upRight">
                    <div class="titleWrap">
                      <div class="title">
                        <p>联系人及联系方式</p>
                      </div>
                    </div>
                      <div class="right-scroll">
                        <vue-scroll :ops="ops" ref="vs">
                          <div class="scroll">
                            <div class="infoWrap" v-for="(item ,index ) in classTrainLinkMan" :key="index">
                              <div class="name">
                                <div class="radius"></div>
                                <span>联系人姓名：{{item.name}}</span>
                              </div>
                              <p>联系人电话：{{item.mobile_phone}}</p>
                              <p>联系人邮箱：{{item.email}}</p>
                            </div>
                          </div>
                        </vue-scroll>
                      </div>
                  </div>
                </div>
                <div class="mainDrown" v-if="admission.qr_code_address">
                  <div class="titleWrap">
                    <div class="title">
                      <p>班级二维码【请务必扫码进群】</p>
                    </div>
                  </div>
                  <div class="downleft">
                    <div class="infoWrap">
                      <div class="detail">
                        <img :src="admission.qr_code_address" alt="" width="200" height="300">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
  
          <div class="post-btn" v-if="admission_status==='confirm_wait'">
            <el-button  type="primary" @click="submit('YES')">参加</el-button>
            <el-button  type="danger" @click="submit('NO')">不参加</el-button>
          </div>
        </div>
        
      </div>
      <template v-if="showTips">
        <yioks-tips :showTips="showTips" :tips="tipsMsg" :loading="Loading" @hideTips="commitData"></yioks-tips>
      </template>
    </template>
  </registration-main>
</template>

<script>
import commonFun from "@/assets/js/yioks";
import { enroll_type,statusKV ,statusKVStudent,LevelFilters,enroll_train_way} from "@/assets/js/status";
const { downfile } = commonFun;
import ops from "@/assets/js/vuescrollOption";
import { pre_admission_info,pre_admission_status_save } from "@/api/training_student/api";
 import {storageData} from "@/assets/js/storage";
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "RegistrationInfo",
  data() {
      const userInfo = storageData.getUserInfo();
    return {
      ops: ops(),
      can_sign_msg:'',
      statusKV,
      statusKVStudent,
      userInfo,
      disScrollOpt: ops(true),
      uuid: this.$route.query.advance_uuid,
      classTrain: {},
      admission: {},
      admission_status:"",
      classTrainLinkMan: [],
      dataPhase: [],
      showDate:true,
      isShowCompleteSelfInfo: false,
      disabled: false,
      showTips:false,
      Loading:false,
      tipsMsg:'',
      advance_status:'',
    };
  },
  components: {
    "registration-main": () => import("@/components/LayOut/Common/up-down"),
    "v-icon": () => import("vue-awesome/components/Icon"),
     "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-tips": () => import('@/components/Tips/Dialog'),
  },
  created() {
    this.getSignUp();
  },
  methods: {
    downloadFile(url) {
      downfile(url);
    },
    goBack() {
      this.$router.go(-1)
    },
    submit(status){
      this.disabled=true
      this.advance_status=status
      if (status==='YES'){
        this.tipsMsg='请确认好时间后，务必扫码进入班级群。'
      } else {
        this.tipsMsg='请确定不参加吗？中国足协将根据培训计划及您选择的意愿时间另行通知。谢谢。'
      }
      this.showTips=true
      this.disabled=false
    },
    commitData(bool,sure){
      if (sure){
        this.Loading=true
        pre_admission_status_save({advance_uuid:this.uuid,status:this.advance_status}).then(res => {
          this.Loading = false;
          this.showTips = false;
          if (res.data.status !== 0) {
            this.$message.error(res.data.msg);
            return
          }
          switch (this.advance_status) {
            case 'NO' :
              this.$router.go(-1);
              break;
            case 'YES' :
              this.getSignUp();
              break;
          }
        }).catch(err => {
          this.Loading = false;
          this.showTips = false;
          console.log(err)
        })
        this.Loading = false;
        this.showTips = false;
      } else{
        this.Loading=false;
        this.showTips=bool
      }
    },
    getSignUp(){
      this.showDate=true;
      pre_admission_info({ advance_uuid: this.uuid })
      .then(res => {
        if (Number(res.data.status) === 0) {
          this.showDate=false;
          const { admission,classTrain,classTrainLinkMan,admission_status,dataPhase } = res.data.result;
          this.admission = admission;
          this.classTrain = classTrain;
          this.dataPhase = dataPhase;
          this.classTrainLinkMan = classTrainLinkMan;
          this.admission_status = admission_status;
        }else{
          this.$message.error(res.data.msg);
        }
      })
      .catch(err => {
        console.error(err);
        this.showDate=true;
      });
    },

  },
  filters:{
    enrollType(type){
      return enroll_type(type)
    },
    enroll_train_way(type){
      return enroll_train_way(type)
    },
      level(level){
          return LevelFilters(level)
      }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';

.registrationDetailNav, .registrationDetailMain {
  flex: 1 1 auto;
  height: 100%;
}

.registrationDetailNav {
  display: flex;
  align-items: center;
  font-size: $font_size_big;
}

.btns {
  display: flex;
  align-items: flex-end;
  margin: 13px 20px 12px;
  .notCommit{
    background-color : $color_background_grey;
    border-color: $color_background_grey;
    cursor:no-drop;
  }

  .btn {
    width: 105px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: $font_size_medium;
    background-color: $color_suc;
    cursor: pointer;
    user-select: none;
  }
}

.registrationDetailMain {
  width: 100%;
  background-color: $block_bg_color_base;

  .mainBody {
    .scrollArea {
      width: 100%;
      height: 550px;
      padding: 15px 0 0;

      .mainDate {
        padding: 20px 50px 0px 50px;
        font-size: $font_size_big;

        .titleWrap {
          margin: 0 0 20px 0;
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          user-select: none;

          .title {
            display: flex;
            align-items: flex-end;


            p {
              line-height: 20px;

              span {
                margin: 0 0 0 10px;
                font-size: $font_size_medium;
              }
            }
          }

          .moreBtn {
            cursor: pointer;
          }
        }

        .mainUp {
          display: flex;
          width: 100%;
          justify-content: space-between;

          .upLeft {
            width: 105%;

            .titleWrap {
              width: 100%;
              padding-bottom: 10px;
              border-bottom: 2px solid white;

              p {
                color: #4cd964;
              }
            }

            .infoWrap {
              p {
                padding-left: 10px;
                margin-bottom: 20px;
              }
            }
          }

          .upRight {
            padding-left: 40px;
            height: 285px;
            width: 100%;

            .titleWrap {
              width: 100%;
              padding-bottom: 10px;
              border-bottom: 2px solid white;

              p {
                color: #4cd964;
              }
            }
            .right-scroll{
              width 360px
              height 220px
              overflow hidden
              .scroll {
                width 100%
                height 200px
                .infoWrap {
                  margin-bottom: 20px;
                  .name {
                    margin-bottom: 10px;
                  }
                }
              }
              .radius {
                display: inline-block;
                height: 10px;
                width: 10px;
                background-color: #4cd964;
                border-radius: 50%;
                margin-right: 10px;
              }

              span {
                padding-bottom: 10px;
              }

              p {
                margin-bottom: 10px;
                padding-left: 20px;
              }
            }
          }
        }

        .mainDrown {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          height: 45%;
          margin-top: 25px;
          position :relative;
          .titleWrap {
            flex-basis: 100%;
            padding-bottom: 10px;
            border-bottom: 2px solid white;
            .title {
              p {
                color: #4cd964;
              }
            }
          }
          .downleft{
            display :flex;
            width :100%;
            .btns{
              position: absolute;
              right: 40px;
              top: 100px;
              .up{
              margin-top -5px
              }
              .down{
                position: relative;
                top: 5px
              }
            }
          }
          .infoWrap {
            flex-basis :100%;
            .detail{
              display flex
              justify-content left
              p{
                word-wrap: break-word;
                word-break: break-all;
                  a{
                    color #4cd964
                  }
              }
              .mainIntro{
                padding 0
                width 410px
              }
            }

            div {
              margin-bottom: 0;

              p {
                padding-left: 15px;
                margin-bottom: 15px;
              }
            }
          }
        }
      }
    }
    .post-btn{
      text-align:center
      .cancel_btn{
        background-color:$color_err;
      }
    }
  }
  .detail-info-dia{
    .scroll-wrap{
      display block
      height 630px
      overflow hidden
      position relative
      .stu-info-box{
        display block
        padding 0 15px
        font-size $font_size_medium
      }
    }
  }
}
.range-item {
  margin-right 10px
  &:not(:last-child)::after {
    content: ''
  }
}

.tips-for-complete
  .little-tips
    height 80px
    display flex
    justify-content: center
    align-items: center
    margin-bottom: 20px
    font-size: 16px
    text-align: center
    line-height 2em
    padding 0 15px
  .btns
    display flex
    align-items center
    justify-content: space-around
</style>
